import { Skeleton, Space } from 'antd';

/** A vertical stack of list-row skeletons — table/list loading placeholder. */
export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} active title={false} paragraph={{ rows: 1 }} />
      ))}
    </Space>
  );
}

/** A single-block skeleton for a page/section still loading. */
export function BlockSkeleton() {
  return <Skeleton active paragraph={{ rows: 4 }} />;
}
